import { render, staticRenderFns } from "./HeartysanCategoryTableBlock.vue?vue&type=template&id=d4dc0cf6&scoped=true"
import script from "./HeartysanCategoryTableBlock.vue?vue&type=script&lang=js"
export * from "./HeartysanCategoryTableBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dc0cf6",
  null
  
)

export default component.exports